import * as Br from '@fixtuur/brenda';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import * as Canvas from './A_Canvas';
export function Component(props) {
    var rendererRef = Hooks.useRef();
    Hooks.useEffect(function () {
        if (rendererRef.current !== undefined) {
            return props.onReady(rendererRef.current);
        }
    }, [rendererRef.current]);
    return (Preact.h(Canvas.Component, { onReady: function (canvas) {
            rendererRef.current = Br.Renderer.create(canvas, props.options);
        } }));
}
Component.displayName = 'BrendaCanvas';
